module.exports = __webpack_public_path__ + "static/media/TYPH.cbd0fa9d.png";